import LectureLessonHistoryListResourceModel from '../../generated/types/model/resource/LectureLessonHistoryListResourceModel';

export default class LectureLessonHistoryListResourceViewModel extends LectureLessonHistoryListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
